import {PATHS} from "../../../../routing/paths";
import {
    CEO,
    CONTACT,
    INN,
    KPP,
    LEGAL_ADDRESS,
    OGRN,
    OPERATOR,
    OPERATOR_SHORT,
    SERVICE,
    type LegalDoc,
} from "./common";

/** Публичная оферта на платные услуги (/offer). */
export const OFFER_DOC: LegalDoc = {
    title: "Публичная оферта",
    linkLabel: "публичная оферта",
    path: PATHS.offer,
    updated: "19 октября 2026 г.",
    sections: [
        {
            title: "1. Общие положения",
            body: [
                `Настоящий документ является публичной офертой (ст. 437 ГК РФ) ${OPERATOR} (далее — Исполнитель), ИНН ${INN}, КПП ${KPP}, ОГРН ${OGRN}, юридический адрес: ${LEGAL_ADDRESS}, генеральный директор ${CEO}, на оказание платных услуг в сервисе ${SERVICE} (далее — Сервис). Сервис включает веб-сайт forruss.ru и мобильное приложение Сервиса для операционной системы Android (далее — Мобильное приложение), распространяемое через магазин приложений RuStore; Мобильное приложение предназначено для пользователей, достигших возраста 18 лет.`,
                "Оплата услуг означает полное и безоговорочное принятие условий настоящей Оферты (акцепт) без подписания двустороннего документа.",
            ],
        },
        {
            title: "2. Платные услуги",
            body: [
                "Premium-подписка — расширенные возможности Сервиса на оплаченный период (просмотр анкет пользователей, отметивших Пользователя лайком; безлимитный возврат к предыдущей карточке; супер симпатии по подписке; приоритет в ленте). Подписка приобретается разовым платежом на 30, 90 или 180 дней без автоматического продления; повторная покупка продлевает срок, прибавляя его к текущему.",
                "В рамках Premium-подписки предоставляется 15 супер симпатий на каждый 30-дневный период подписки, отсчитываемый от даты оплаты. Неиспользованные за период супер симпатии сгорают в конце периода и не переносятся на следующий. Супер симпатии из приобретённых пакетов и стартовые не сгорают.",
                "Пакеты супер симпатий — разовое пополнение баланса супер симпатий.",
                "Детальный ИИ-разбор совместимости — платная услуга, приобретается отдельно от Premium-подписки: разовый доступ к подробному отчёту по выбранной анкете или пакет разборов.",
                "Виртуальные подарки — отправка подарка собеседнику в чате.",
                "Актуальные цены и состав услуг указываются в интерфейсе Сервиса (в том числе в Мобильном приложении) в момент покупки. Все цены указаны в рублях РФ.",
            ],
        },
        {
            title: "3. Порядок оплаты и предоставления услуг",
            body: [
                "Оплата производится банковской картой или иными доступными способами через платёжного провайдера. Услуга активируется после подтверждения платежа.",
                "Электронный чек направляется на адрес электронной почты, указанный при оплате.",
                "Оплаченная услуга считается оказанной с момента её активации в личном кабинете Пользователя. Приобретённые услуги (подписка, супер симпатии, баллы) доступны Пользователю как в веб-версии Сервиса, так и в Мобильном приложении при входе в ту же учётную запись.",
            ],
        },
        {
            title: "4. Возвраты",
            body: [
                "Если оплаченная услуга не была оказана по вине Исполнителя (платёж подтверждён, но услуга не активирована), средства возвращаются в полном объёме по обращению в поддержку.",
                "Возврат за фактически оказанные услуги (использованные супер симпатии, истёкший период подписки, открытые отчёты, доставленные подарки) не производится, за исключением случаев, предусмотренных законодательством РФ.",
                `Обращения по возвратам: ${CONTACT} или раздел «Поддержка» в приложении. Срок рассмотрения — до 10 рабочих дней.`,
            ],
        },
        {
            title: "5. Бонусная программа (баллы и промокоды)",
            body: [
                "Исполнитель начисляет Пользователю бонусные баллы за активности в сервисе: заполнение анкеты — 10 баллов (однократно), 7 дней входа в сервис подряд — 15 баллов, оплата услуги приглашённым Пользователем по персональной ссылке — 50 баллов. Состав активностей и размеры начислений могут уточняться Исполнителем в интерфейсе сервиса.",
                "При достижении 50 баллов сервис автоматически формирует персональный промокод: скидка 15% на любую платную услугу, срок действия — 14 календарных дней с момента выдачи, одна активация. Промокод доступен в разделе «Мои баллы» личного кабинета и дублируется уведомлением.",
                "Баллы не являются денежными средствами, не покупаются, не продаются и не подлежат обмену на деньги. Баллы не начисляются и аннулируются за недобросовестные действия (массовые регистрации, само-приглашения, иные попытки обхода правил программы).",
                "При возврате оплаты, за которую были начислены баллы, начисленные за эту оплату баллы аннулируются. Если промокод уже был сгенерирован на основе этих баллов, активация такого промокода может быть отменена, а скидка не применялась к возвратной оплате.",
            ],
        },
        {
            title: "6. Персональные данные",
            body: [
                `Исполнитель обрабатывает персональные данные Пользователя в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и Политикой, размещённой по адресу ${PATHS.privacy}.`,
                "При совершении оплаты Пользователь соглашается с передачей необходимых данных платёжному провайдеру для исполнения платежа.",
            ],
        },
        {
            title: "7. Изменение оферты",
            body: [
                "Исполнитель вправе изменять состав, стоимость и условия услуг, публикуя изменения на этой странице. Изменения не затрагивают уже оплаченные услуги.",
                "Во всём, что не урегулировано Офертой, стороны руководствуются Пользовательским соглашением и законодательством РФ.",
            ],
        },
    ],
};
